package org.zest.insan_360_website

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.zest.insan_360_website.components.layouts.userPageColor
import org.zest.insan_360_website.components.widgets.*
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.UserPreferences

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("html, body") { Modifier.fillMaxHeight() }
}

@InitSilk
fun initFonts(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyleBase("body, button, input, select, textarea") {
        Modifier.fontFamily("FunnelDisplay")
    }
}

@InitSilk
fun initScrollbarStyle(ctx: InitSilkContext) {
    ctx.stylesheet.registerStyle("::-webkit-scrollbar") {
        base {
            Modifier
                .width(8.px)
                .height(8.px)
                .borderRadius(4.px)
        }
    }
    ctx.stylesheet.registerStyle("::-webkit-scrollbar-track") {
        base {
            Modifier.backgroundColor(Colors.Transparent)
        }
    }
    ctx.stylesheet.registerStyle("::-webkit-scrollbar-thumb") {
        base {
            Modifier
                .backgroundColor(userPageColor.darkened(0.25f))
                .borderRadius(4.px)
        }
    }
    ctx.stylesheet.registerStyle("::-webkit-scrollbar-thumb:hover") {
        base {
            Modifier.backgroundColor(userPageColor.darkened(0.5f))
        }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    var ready by remember { mutableStateOf(false) }
    val toastState = remember { ToastState() }
    val modalState = remember { ModalState() }

    LaunchedEffect(Unit) {
        UserPreferences.loadPreferences()
        AuthState.load()
        ready = true
    }

    SilkApp {
        CompositionLocalProvider(
            LocalToast provides toastState,
            LocalModal provides modalState
        ) {
            Surface(SmoothColorStyle.toModifier().then(Modifier.overflow(Overflow.Clip))) {
                if (ready) content()
            }
            ModalContainer(modalState)
            ToastContainer(toastState)
        }
    }
}
